var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: _vm.wrapperClass, attrs: { "data-qa": "payment-type:Deposit" } },
    [
      _c(
        "div",
        {
          staticClass: "_cur-p _pa-3 _pos-r",
          on: {
            click: function ($event) {
              return _vm.onSelectPaymentType()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "gfu-card__labels" },
            [
              _c(
                "base-badge",
                {
                  key: _vm.badgeProps.name,
                  staticClass: "_mr-1 _my-1",
                  attrs: {
                    theme: _vm.badgeProps.theme,
                    "data-qa": `reward-card-badge:${_vm.badgeProps.dataQa}`,
                  },
                },
                [
                  _vm.badgeProps.icon
                    ? _c("base-icon", { attrs: { name: _vm.badgeProps.icon } })
                    : _vm._e(),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.badgeProps.name) +
                      "\n            "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_flex _ai-c" },
            [
              _c("checkbox-field", {
                staticClass: "_mt-0 _mr-2",
                attrs: {
                  "show-label": false,
                  name: "paymentTypeItem",
                  type: "radio",
                },
                model: {
                  value: _vm.isSelected,
                  callback: function ($$v) {
                    _vm.isSelected = $$v
                  },
                  expression: "isSelected",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "_flexcol" },
                [
                  _c(
                    "localize",
                    {
                      key: _vm.depositAmountFormatted,
                      attrs: {
                        resource:
                          _vm.Resources.Checkout
                            .CheckoutPaymentTypeDepositLabel,
                      },
                    },
                    [
                      _c("span", { attrs: { "format-key": "0" } }, [
                        _vm._v(_vm._s(_vm.depositAmountFormatted)),
                      ]),
                      _vm._v(" "),
                      _c("span", { attrs: { "format-key": "1" } }, [
                        _vm._v(_vm._s(_vm.depositPercentageFormatted)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }